import { getHardwareTypeName } from './getHardwareTypeName'
import { isShippable, robotDeactivated } from './stringTransformers'
import { DetailedSubscriptionChain, DetailedSubscriptionChainResponse, RobotAccount, DetailedRobot, DetailedRobotResponse, DetailedTaas, DetailedTaasResponse, DetailedTaasOrder } from './types/types'

export const mapRobotDetailedResponseToRobotDetailed = (robotDetailedResponse?: DetailedRobotResponse, account?: RobotAccount): DetailedRobot => {
  let robotDetailed: DetailedRobot
  if (robotDetailedResponse) {
    robotDetailed = {
      ...robotDetailedResponse,
      deactivated: robotDeactivated(robotDetailedResponse),
      shippable: isShippable(robotDetailedResponse),
      account: account ? { ...account } : undefined,
      hardwareTypeLabel: getHardwareTypeName(robotDetailedResponse.hardwareType)
    }
  }

  return robotDetailed
}

export const mapTaasDetailedResponseToTaasDetailed = (taasDetailedResponse?: DetailedTaasResponse, order?: DetailedTaasOrder): DetailedTaas => {
  let taasDetailed: DetailedTaas
  if (taasDetailedResponse) {
    taasDetailed = {
      ...taasDetailedResponse,
      order: order || undefined,
      canceled: !!taasDetailedResponse.endAt,
      delete: !!taasDetailedResponse.archivedAt
    }
  }

  return taasDetailed
}

export const mapChainDetailedResponseToChainDetailed = (chainDetailedResponse: DetailedSubscriptionChainResponse): DetailedSubscriptionChain => {
  let chainDetailed: DetailedSubscriptionChain
  if (chainDetailedResponse) {
    chainDetailed = {
      ...chainDetailedResponse,
      cancelled: !!chainDetailedResponse.canceledAt
    }
  }
  return chainDetailed
}
